import type { WorkOrderChangeObjectItem, WorkOrderObjectData, WorkOrderVersionObjectData } from 'gql/graphql';
import { Combobox } from 'uikit';

import { useMemo } from 'react';

interface IConstructionObjectComboboxProps {
    constructionTypeId: number;
    objectId: number | undefined;
    onChange: (filters: any) => void;
    workOrderObjects:
        | (WorkOrderObjectData | WorkOrderVersionObjectData | WorkOrderChangeObjectItem)[]
        | null
        | undefined;
    disabled?: boolean;
    getItemDisabled?: (item: { id: any; label: string }) => boolean;
    getItemLabel?: (item: { id: any; label: string }) => any;
}

export const ConstructionObjectCombobox = ({
    constructionTypeId,
    objectId,
    onChange,
    disabled,
    workOrderObjects,
    getItemDisabled,
    getItemLabel,
}: IConstructionObjectComboboxProps) => {
    const objectsItems = useMemo(
        () =>
            (workOrderObjects ?? [])
                .filter(
                    ({ constructionType, parentId }) => parentId === null && constructionTypeId === constructionType.id,
                )
                .map(({ id, name }) => ({ id, label: name })),
        [constructionTypeId, workOrderObjects],
    );

    const selectedItem = useMemo(() => objectsItems.find(({ id }) => id === objectId), [objectId, objectsItems]);

    return (
        <Combobox
            placeholder="Объект строительства"
            items={objectsItems}
            value={selectedItem}
            onChange={onChange}
            size="s"
            disabled={!objectsItems.length || disabled}
            getItemDisabled={getItemDisabled}
            getItemLabel={getItemLabel}
        />
    );
};

ConstructionObjectCombobox.displayName = 'ConstructionObjectCombobox';
